module.exports = __webpack_public_path__ + "img/add.7a63364d.svg";